import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  number: '+3.000',
  label: 'Chefs ya lo están usando'
}, {
  number: '+70%',
  label: 'De tripulaciones internacionales trabajan con referencias y CV optimizados'
}, {
  number: '+USD',
  label: 'Miles de dólares potenciales según experiencia y posición'
}];
export function SocialProof() {
  return <section className="py-12 bg-secondary/30 border-y border-border/50" data-id="element-169">
      <div className="px-5" data-id="element-170">
        <div className="divide-y divide-border/50" data-id="element-171">
          {stats.map((stat, index) => <motion.div key={index} className="text-center py-8 first:pt-0 last:pb-0" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} data-id="element-172">
              <h3 className="text-5xl font-bold text-primary mb-2 font-heading drop-shadow-[0_0_15px_rgba(212,168,87,0.3)]" data-id="element-173">
                {stat.number}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed px-4" data-id="element-174">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}